var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLearningAtDifferentStationsWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 132.541,
    height: 132.483,
    viewBox: "0 0 132.541 132.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2159",
    "data-name": "Ret\\xE2ngulo 2159",
    width: 132.541,
    height: 132.483,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09d785"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-learning-at-different-stations-white",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4200",
    "data-name": "Grupo 4200",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1937",
    "data-name": "Caminho 1937",
    d: "M0,74.51a7.814,7.814,0,0,0,.694-.547Q14.832,59.838,28.96,45.7c.152-.152.291-.315.507-.549-.315-.342-.615-.683-.934-1Q16.414,32.027,4.3,19.9C-.321,15.282-.29,9.614,4.3,4.955c1.819-1.838,3.728-3.483,6.374-3.93A9.846,9.846,0,0,1,19.719,4.04Q31.873,16.218,44.044,28.377c.334.334.615.719.886,1.044Q59.8,14.555,74.352,0c19.421,19.421,38.643,38.646,58.189,58.191a6.329,6.329,0,0,0-1.2.8Q95.1,95.2,58.89,131.432c-.328.328-.61.7-.915,1.051h-.258a8.84,8.84,0,0,0-.571-.681Q28.916,103.564.681,75.336c-.207-.207-.454-.381-.681-.568Zm57.841,51.823,68.468-68.466L74.654,6.2,48.1,32.754a7.331,7.331,0,0,1,1.091.778q6.01,5.976,11.979,11.989a3.219,3.219,0,0,1,.87,1.64c.659,4.257,1.252,8.526,1.853,12.793.207,1.467.384,2.937.589,4.517-6.055-.862-11.9-1.678-17.731-2.556a2.639,2.639,0,0,1-1.247-.828q-6.015-5.976-11.989-11.979c-.324-.324-.663-.628-.818-.776Q19.366,61.666,6.278,74.757l51.568,51.576Zm-.849-79.277a12.356,12.356,0,0,1-1.117-.9C43.2,33.534,30.451,20.98,17.9,8.227c-3.6-3.652-7.127-4.2-10.91.12-2.316,2.637-2.459,5.65,0,8.163q4.156,4.255,8.348,8.474,15.49,15.51,31,31c.295.295.6.568.839.791l3.426-3.3Q34.178,37.044,17.863,20.74l2.964-3.123Q37.3,34.1,53.589,50.382L57,47.059ZM51.849,58.412c2.647.376,5.1.719,7.7,1.093-.384-2.627-.741-5.088-1.139-7.806-2.188,2.2-4.159,4.18-6.129,6.163-.12.12-.205.258-.434.547Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1938",
    "data-name": "Caminho 1938",
    d: "M42.544,90.377c1.719,1.73,3.559,3.6,5.41,5.445,1.53,1.53,2.508,1.53,4.041,0q5.26-5.249,10.5-10.514a7.759,7.759,0,0,0,.789-1.131l3.094,3.149c-.126.141-.36.436-.621.7Q60.324,93.467,54.885,98.9c-3.117,3.1-6.741,3.07-9.875-.047-1.859-1.851-3.716-3.7-5.553-5.524,1.015-.97,1.964-1.877,3.081-2.947Z",
    transform: "translate(7.846 16.739)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1939",
    "data-name": "Caminho 1939",
    d: "M45.162,72.414,24.31,51.564l2.732-2.637L47.931,69.818Z",
    transform: "translate(4.834 9.73)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1940",
    "data-name": "Caminho 1940",
    d: "M18.955,56.839c.915-.908,1.829-1.811,2.608-2.585l20.99,20.992-2.6,2.582Z",
    transform: "translate(3.769 10.789)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1941",
    "data-name": "Caminho 1941",
    d: "M37.372,80.38,34.63,83.018,13.8,62.191c.828-.839,1.787-1.8,2.682-2.7L37.372,80.378Z",
    transform: "translate(2.744 11.83)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1942",
    "data-name": "Caminho 1942",
    d: "M76.73,26.681c-.778.744-1.735,1.659-2.582,2.466Q66.9,21.9,59.546,14.539l2.566-2.479Z",
    transform: "translate(11.841 2.398)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1943",
    "data-name": "Caminho 1943",
    d: "M71.53,31.94c-.886.839-1.82,1.722-2.637,2.49L54.254,19.791l2.566-2.556C61.7,22.11,66.563,26.973,71.53,31.94",
    transform: "translate(10.789 3.427)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1944",
    "data-name": "Caminho 1944",
    d: "M48.956,25.344c.921-1,1.816-1.977,2.671-2.9Q59,29.817,66.268,37.083L63.521,39.9,48.952,25.341Z",
    transform: "translate(9.734 4.462)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1945",
    "data-name": "Caminho 1945",
    d: "M97.4,49.594l.026-.026,2.757-2.757-.042-.04q-5.9-5.9-11.847-11.85l-.008-.008L85.5,32.131l-.11.12L73.624,44.027l-.12.128q-1.329,1.333-2.664,2.666c.037.037.073.073.11.108L82.734,58.7l.439.428c.784.78,1.559,1.559,2.351,2.347l.134-.137q5.857-5.857,11.755-11.749ZM85.506,55.919,76.4,46.807l9.1-9.1,9.105,9.1Z",
    transform: "translate(14.087 6.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1946",
    "data-name": "Caminho 1946",
    d: "M81.037,65.7l.026-.026,2.757-2.757-.042-.04L71.932,51.031l-.008-.008-2.781-2.781-.11.12L57.264,60.137l-.12.128Q55.815,61.6,54.48,62.932c.037.037.073.073.11.108L66.374,74.812l.439.428c.784.78,1.559,1.559,2.351,2.347l.134-.137Q75.155,71.594,81.053,65.7ZM69.146,72.029,60.04,62.917l9.1-9.1,9.105,9.1Z",
    transform: "translate(10.834 9.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1947",
    "data-name": "Caminho 1947",
    d: "M63.955,83.038l.026-.026,2.757-2.757-.042-.04q-5.9-5.9-11.847-11.85l-.008-.008L52.06,65.575l-.11.12L40.182,77.471l-.12.128q-1.329,1.333-2.664,2.666c.037.037.073.073.11.108L49.292,92.146l.439.428c.784.78,1.559,1.559,2.351,2.347l.134-.137q5.857-5.857,11.755-11.749ZM52.064,89.363l-9.105-9.111,9.1-9.1,9.105,9.1Z",
    transform: "translate(7.437 13.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1948",
    "data-name": "Caminho 1948",
    d: "M61.789,82.787c1.328-1.333,2.66-2.669,3.918-3.927l2.81,2.8c-1.236,1.186-2.616,2.518-4.035,3.876l-2.689-2.75Z",
    transform: "translate(12.287 15.682)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1949",
    "data-name": "Caminho 1949",
    d: "M29.337,45.009c-.315-.342-.615-.683-.934-1Q16.284,31.884,4.165,19.759C-.451,15.139-.42,9.471,4.165,4.812,5.984,2.975,7.894,1.33,10.54.883A9.846,9.846,0,0,1,19.589,3.9Q31.743,16.076,43.914,28.235c.334.334.615.719.886,1.044l3.169,3.333a7.332,7.332,0,0,1,1.091.778q6.01,5.976,11.979,11.989a3.219,3.219,0,0,1,.87,1.64c.659,4.257,1.252,8.526,1.853,12.793.207,1.467.384,2.937.589,4.517-6.055-.862-11.9-1.678-17.731-2.556a2.639,2.639,0,0,1-1.247-.828q-6.015-5.976-11.989-11.979c-.324-.324-.663-.628-.818-.776Zm27.526,1.9a12.355,12.355,0,0,1-1.117-.9C43.067,33.392,30.321,20.838,17.769,8.084c-3.6-3.652-7.127-4.2-10.91.12-2.316,2.637-2.459,5.65,0,8.163q4.156,4.255,8.348,8.474,15.49,15.51,31,31c.295.295.6.568.839.791l3.426-3.3Q34.048,36.9,17.733,20.6L20.7,17.475Q37.171,33.954,53.459,50.24l3.41-3.323ZM51.719,58.27c2.647.376,5.1.719,7.7,1.093-.384-2.627-.741-5.088-1.139-7.806-2.188,2.2-4.159,4.18-6.129,6.163-.12.12-.205.258-.434.547Z",
    transform: "translate(0.142 0.142)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLearningAtDifferentStationsWhite);
export default __webpack_public_path__ + "static/media/icon-learning-at-different-stations-white.ac593fd77f46c8da4be37491ea2aae65.svg";
export { ForwardRef as ReactComponent };